module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"close btn-close\"> <img src=\"https://content.votenow.tv/app/projects/mtv/vmas-2021/btn-x-black.png\" alt=\"Close Modal\"> </div> <h1><%- text.header %></h1> <p><%- text.description %></p> <div class=\"poll-wrapper\"> <% data.forEach( function( question ) { %> <img src=\"<%- question.question_image %>\" alt=\"Poll Question Image\"> <% if( !completed ) { %> <h2><%- question.question %></h2> <% question.answers.forEach( function( answer, index ) { %> <div class=\"answer-group\"> <img src=\"<%= question.answer_images[index] %>\" alt=\"<%= answer %>\"> <button class=\"btn-poll\"><%- answer %></button> </div> <% }); %> <% } else { %> <div class=\"thanks-wrapper\"> <h2><%- text.thanks.header %></h2> <p><%- text.thanks.description %></p> <p class=\"code\"><%- text.thanks.code %></p> </div> <% } %> <% }); %> </div> <% if ( text.sponsor.sponsor_image  ) { %> <div class=\"sponsor\"> <span><%- text.sponsor.sponsor_label %></span> <img src=\"<%- text.sponsor.sponsor_image %>\" alt=\"\"> </div> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="close btn-close"> <img src="https://content.votenow.tv/app/projects/mtv/vmas-2021/btn-x-black.png" alt="Close Modal"> </div> <h1>', (__stack.lineno=1,  text.header ), '</h1> <p>', (__stack.lineno=1,  text.description ), '</p> <div class="poll-wrapper"> ');__stack.lineno=1; data.forEach( function( question ) { ; buf.push(' <img src="', (__stack.lineno=1,  question.question_image ), '" alt="Poll Question Image"> ');__stack.lineno=1; if( !completed ) { ; buf.push(' <h2>', (__stack.lineno=1,  question.question ), '</h2> ');__stack.lineno=1; question.answers.forEach( function( answer, index ) { ; buf.push(' <div class="answer-group"> <img src="', escape((__stack.lineno=1,  question.answer_images[index] )), '" alt="', escape((__stack.lineno=1,  answer )), '"> <button class="btn-poll">', (__stack.lineno=1,  answer ), '</button> </div> ');__stack.lineno=1; }); ; buf.push(' ');__stack.lineno=1; } else { ; buf.push(' <div class="thanks-wrapper"> <h2>', (__stack.lineno=1,  text.thanks.header ), '</h2> <p>', (__stack.lineno=1,  text.thanks.description ), '</p> <p class="code">', (__stack.lineno=1,  text.thanks.code ), '</p> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; }); ; buf.push(' </div> ');__stack.lineno=1; if ( text.sponsor.sponsor_image  ) { ; buf.push(' <div class="sponsor"> <span>', (__stack.lineno=1,  text.sponsor.sponsor_label ), '</span> <img src="', (__stack.lineno=1,  text.sponsor.sponsor_image ), '" alt=""> </div> ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/poll.ejs
// module id = 257
// module chunks = 0